<template>
  <div class="hello">
    <h1>{{ msg }}</h1>
    <p>
      Wir freuen uns, Sie auf unserer Webpräsenz begrüßen zu dürfen.<br>
      Sollten Sie irgendwelche Fragen zu unserer Verbindung haben, zu denen Sie hier <br>
      keine Antworten finden, dann schreiben Sie gerne an <a href="mailto:info@pv-bund.de">info@pv-bund.de</a>.
    </p>
    <!--
    <h3>Aktuelles</h3>
    <ul>
      <li><a href="http://localhost:8088/downloadFile/SemesterprogrammWS_18_19.pdf" target="_blank" rel="noopener">Aktuelles Semesterprogramm</a></li>
    </ul>
    -->
  </div>
</template>

<script>
export default {
  name: 'LandingPage',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
